import { Box, Typography, Divider, Button } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import CohortLeaderboard from 'components/molecules/home/CohortLeaderboard'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { GoalImageContainer } from 'components/molecules/home/PathCardMolecules'
import { CurrentPathProgress } from 'components/molecules/home/CurrentPathMolecules'
import CurrentPathMilestones from 'components/molecules/home/CurrentPathMilestones'
import { formatDate } from 'utils/formatDateTime'
import colors from 'styles/colors'

const CurrentPathArea = ({
  goal,
  futureSession,
  cohortRanking,
  showMyPath
}) => {
  const { t } = useTranslation()
  const leaderboardShown = cohortRanking || futureSession
  return (
    <Grid container spacing={6}>
      {goal ? (
        <>
          <Grid
            flexGrow={1}
            maxWidth={leaderboardShown ? 'calc(100% - 380px)' : '100%'}>
            <BoxWithBackground
              sx={{ padding: 10, paddingBottom: 16, height: '100%' }}>
              <ColStack spacing={8}>
                <Typography variant='h3'>{t('headers.currentPath')}</Typography>
                <RowStack spacing={16} alignItems={'flex-start'}>
                  <RowStack
                    spacing={0}
                    sx={{
                      gap: 12,
                      width: 'auto',
                      alignItems: 'flex-start',
                      '@media (max-width:1400px)': {
                        flexDirection: 'column'
                      }
                    }}>
                    <GoalImageContainer
                      goal={goal}
                      isLibrary={false}
                      sx={{
                        width: 240,
                        height: 139,
                        borderRadius: 2
                      }}>
                      {(goal.completed || goal.opensAt) && (
                        <>
                          <Box />
                          <Typography
                            variant='h3'
                            sx={{ color: colors.White, alignSelf: 'center' }}>
                            {goal.completed
                              ? t('common.completed')
                              : `${t('home.starts')} ${formatDate(goal.opensAt)}`}
                          </Typography>
                          <Box />
                        </>
                      )}
                    </GoalImageContainer>

                    <CurrentPathProgress
                      goal={goal}
                      leaderboardShown={leaderboardShown}
                    />
                  </RowStack>

                  <Divider
                    orientation='vertical'
                    sx={{ height: 158, alignSelf: 'center' }}
                  />

                  <CurrentPathMilestones
                    goal={goal}
                    leaderboardShown={leaderboardShown}
                  />
                </RowStack>
              </ColStack>
            </BoxWithBackground>
          </Grid>
          {leaderboardShown && (
            <CohortLeaderboard
              cohortRanking={cohortRanking}
              futureSession={futureSession}
            />
          )}
        </>
      ) : (
        <BoxWithBackground width='100%' padding={8}>
          <ColStack spacing={8}>
            <Typography>
              {t('home.noCurrentUpcomingPaths')}
              {t('home.canViewCompletedPaths')}
            </Typography>
            <Button color='primary' size='small' onClick={() => showMyPath()}>
              {t('home.myPaths')}
            </Button>
          </ColStack>
        </BoxWithBackground>
      )}
    </Grid>
  )
}

export default CurrentPathArea
